import { CertificateValue } from './valueObjects/CertificateValue';
import { PublicKey } from './valueObjects/PublicKey';

export class CertificateDetail {
  constructor(
    private readonly id: number,
    private readonly publicKey: PublicKey,
    private readonly isSelfSigned: boolean | null,
    private readonly isCa: boolean | null,
    private readonly value: CertificateValue,
    private readonly encoded: string | null
  ) {}

  getId() {
    return this.id;
  }

  getPublicKey() {
    return this.publicKey;
  }

  getIsSelfSigned() {
    return this.isSelfSigned;
  }

  getIsCa() {
    return this.isCa;
  }

  getValue() {
    return this.value;
  }

  getEncoded() {
    return this.encoded;
  }
}
